/**
 * Landscape-orientation prompt for mobile learners.
 */
import React from "react";
import { Icon } from "@iconify/react";

import VText from "form/VText";
import useOrientation from "utils/device";

/**
 * Prompts mobile learners to rotate into landscape.
 */
const PageFixer = () => {
  const { isDesktop, isLandscape } = useOrientation();

  return (
    <div className="fixed z-50 right-3 bottom-2">
      {!isDesktop && !isLandscape && (
        <VText color="secondary">
          <Icon icon="mdi:phone-rotate-landscape" className="text-4xl" />
        </VText>
      )}
    </div>
  );
};

export default PageFixer;
